export default "__VITE_ASSET__5TPLWQyd__"